//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {countDone} from '../utils.js';
import {formatDateChip} from '../time-utils.js';

export default {
  props: [
    'item',
  ],
  data() {
    return {
    };
  },
  methods: {
    getInitials(name) {
      const teamSettings = this.$reactiveCache.metadata[this.item.couch.name]?.settings
      if (teamSettings?.initials && teamSettings?.initials[name]) {
        return teamSettings?.initials[name]
      }
      // Include digits, as some usernames may differ only by number
      const initials = name.split(/[^a-z0-9]/i).map(word => word[0]).join('')
      return initials.toUpperCase().substring(0, 2);
    },
  },
  computed: {
    elements() {
      return this.item.getChildren();
    },
    subtasks() {
      return this.elements.filter((item) => {return item.type === 'task'});
    },
    notes() {
      return this.elements.filter((item) => {return item.type === 'note'});
    },
    doneSubtasksCount() {
      return countDone(this.subtasks);
    },
    isShared() {
      return this.item.couch.collaborators.length > 1
    },
    showMembers() {
      return this.item.couch.collaborators.length > 1 && this.item.assignees
    },
    dateChipText() {
      const pf = this.item.plannedFor;
      return (pf.parentClass === 'list' && pf.parentKey !== 'backlog')
        ? this.$reactiveCache.docs[pf.parentKey].name
        : formatDateChip(pf, this.$gettext);
    },
    labels() {
      if (this.item.labels) {
        return this.item.labels
          .map(id => this.$reactiveCache.docs[id])
          .filter(doc => !!doc);
      } else {
        return [];
      }
    },
  },
};
